// ABOUTME: Global catalog metadata is cross-country, so editing it requires a global admin role,
// ABOUTME: not merely per-country config access (HCP-111556).
import {useSelector} from 'react-redux'

import {selectLoggedInUserProfile} from '../../../../modules/LoggedInUser.selectors'

export const GLOBAL_CATALOG_ROLES = ['GLOBAL_ADMIN', 'SUPER_ADMIN']

export const useCanEditGlobalCatalog = (): boolean => {
  const profile = useSelector(selectLoggedInUserProfile)
  return Boolean(profile?.hasRoles?.some((role: string) => GLOBAL_CATALOG_ROLES.includes(role)))
}
